import React from 'react'
import "../styles/Categories.css"


function Categories({plantCategorie,setPlantCategorie,categories}) {
  const handleSelectPlantCategorie = async (e) => {
      await setPlantCategorie(e.target.value);
  }
  return (
   
    <div className="select">
        <select name="plantCategorie"
                value={plantCategorie}
                id="plantCategorie"
                onChange={(e) => handleSelectPlantCategorie(e)}
        >
            <option value="">---</option>
            {categories.map((cat) => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
        </select>
        <button className="reset-button" onClick={() => setPlantCategorie('')}>Réinitialiser</button>
        {console.log(plantCategorie)}
       
    </div>
  )
}

export default Categories